export const FILE_ERRORS = {
	INVALID_TYPE: 'Only PDF files are allowed.',
	SIZE_EXCEEDED: 'File size exceeds 10MB.',
	UPLOAD_FAILED: 'File upload failed.',
	DELETE_FAILED: 'File delete failed.',
	DELETE_EVIDENCE_FAILED: 'Failed to delete evidence file.',
} as const
